import { render, staticRenderFns } from "./PrivacyMediaEmbed.vue?vue&type=template&id=f0c4e5c8&scoped=true"
import script from "./PrivacyMediaEmbed.vue?vue&type=script&lang=js"
export * from "./PrivacyMediaEmbed.vue?vue&type=script&lang=js"
import style0 from "./PrivacyMediaEmbed.vue?vue&type=style&index=0&id=f0c4e5c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c4e5c8",
  null
  
)

export default component.exports